import {ComponentClass, FunctionComponent} from 'react';
import HttpException from './HttpException';
import {UnsafeHTML} from '../@types/UnsafeHTML';

export type ErrorMessageComponentProps = { error: AbstractPrintableHttpException };
export type ErrorMessageComponent =
    FunctionComponent<ErrorMessageComponentProps> |
    ComponentClass<ErrorMessageComponentProps>;

export default abstract class AbstractPrintableHttpException extends HttpException {
    protected shouldBeReported = false;

    protected shouldBeRetried = false;

    getRepresentationTitle(): string {
        return this.name;
    }

    abstract getMessageComponent(): ErrorMessageComponent | null;

    abstract getHtmlResponse(): UnsafeHTML | null;
}
